<script lang="ts" setup></script>

<template>
  <v-chip class="bg-indigo-lighten-2" density="comfortable" size="small">Planned</v-chip>
</template>
